// After anything is added to the cart, tell the tracking pixel what the cart is really worth
// (discounts included). The Meta pixel in Customer events listens for "c_cart_value".
(function () {
  if (window.__cCartValue) return;
  window.__cCartValue = true;
  var timer;
  function publish() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    originalFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
        Shopify.analytics.publish('c_cart_value', {
          total: cart.total_price / 100,
          currency: cart.currency,
          items: (cart.items || []).map(function (i) {
            return { id: String(i.variant_id), quantity: i.quantity, price: i.final_line_price / 100 / (i.quantity || 1), title: i.product_title };
          }),
        });
      })
      .catch(function () {});
  }
  var originalFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      result.then(function (r) {
        if (!r.ok) return;
        clearTimeout(timer);
        timer = setTimeout(publish, 1200); // wait for the gifts that are added right after
      }).catch(function () {});
    }
    return result;
  };
})();
